import { useEffect, useState, Fragment } from "react";

import {
  Grid,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Container,
  Select,
  Input,
  MenuItem,
  Button,
  Tooltip,
} from "@mui/material";

import { makeStyles } from "@mui/styles";

import { useLocation } from "react-router-dom";

import { backend, API_URL } from "../../../../config";

import BlockIcon from "@mui/icons-material/Block";

const columns = {
  nonbulk: [
    {
      id: "order",
      label: "Order",
      minWidth: 50,
      align: "center",
    },
    {
      id: "bin",
      label: "Bin Location",
      minWidth: 50,
      align: "center",
    },
    {
      id: "name",
      label: "Item Name",
      minWidth: 50,
      align: "center",
    },
    {
      id: "item_codee",
      label: "Item Code",
      minWidth: 50,
      align: "center",
    },
    {
      id: "unit_quantity",
      label: "Unit Qty",
      minWidth: 50,
      align: "center",
    },
    {
      id: "price_per_unit",
      label: "Unit Price",
      minWidth: 50,
      align: "center",
    },
    {
      id: "case_quantity",
      label: "Case Qty",
      minWidth: 50,
      align: "center",
    },
    {
      id: "price_per_case",
      label: "Case Price",
      minWidth: 50,
      align: "center",
    },
  ],
  bulk: [
    {
      id: "bin",
      label: "Bin Location",
      minWidth: 20,
      align: "center",
    },
    {
      id: "name",
      label: "Item Name",
      minWidth: 50,
      align: "center",
    },
    {
      id: "item_codee",
      label: "Item Code",
      minWidth: 50,
      align: "center",
    },
    {
      id: "unit_quantity",
      label: "Unit Qty",
      minWidth: 50,
      align: "center",
    },
    {
      id: "price_per_unit",
      label: "Unit Price",
      minWidth: 50,
      align: "center",
    },
    {
      id: "case_quantity",
      label: "Case Qty",
      minWidth: 50,
      align: "center",
    },
    {
      id: "price_per_case",
      label: "Case Price",
      minWidth: 50,
      align: "center",
    },
  ],
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 440,
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  customTable: {
    "& .MuiTableCell-sizeSmall": {
      padding: "6px 0px 6px 8px",
    },
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const PickListDetailsPrint = (props) => {
  const classes = useStyles();
  const location = useLocation();

  const { filterState, bulkState, dateRangeState, ordersState, orderItems } =
    location.state;

  const [filter, setFilter] = useState(filterState);
  const [hidePicked, setHidePicked] = useState(false);
  const [showPrices, setShowPrices] = useState(false);
  const [orders, setOrders] = useState([]);
  const [ordersGroup, setOrdersGroup] = useState(null);
  const [orderItemsFull, setOrderItemsFull] = useState(orderItems);
  const [orderLocation, setOrderLocation] = useState(null);

  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilter(value);
  };

  const handleShowPrices = () => {
    setShowPrices(!showPrices);
  };

  const handleHidePicked = () => {
    setHidePicked(!hidePicked);
  };

  useEffect(() => {
    const getOrderCompanyLocation = async () => {
      await backend
        .get(`${API_URL}companylocations/${ordersState[0].company_location.id}`)
        .then(({ data }) => {
          setOrderLocation(data);
        });
    };
    setOrders(ordersState.map((item) => item.id));
    setOrdersGroup(() => {
      let ordersGroupObj = {};
      ordersState.forEach((item) =>
        ordersGroupObj.hasOwnProperty(item.customer.username)
          ? ordersGroupObj[item.customer.username].push(item.id)
          : (ordersGroupObj[item.customer.username] = [item.id])
      );

      return ordersGroupObj;
    });

    if (ordersState.length === 1) {
      getOrderCompanyLocation();
    }
  }, [ordersState]);

  useEffect(() => {
    const filterOrderItems = () => {
      setOrderItemsFull(() =>
        orderItems.filter((item) =>
          filter === "" ? true : item.warehouse.id === +filter
        )
      );
    };

    filterOrderItems();
  }, [filter, orderItems]);

  return (
    <>
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <Typography variant="h6" component="div">
              Pick List
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1">
              <strong>Included Orders: </strong>
              {ordersGroup
                ? Object.keys(ordersGroup).map((item, index) => (
                    <Fragment key={`customer-${index}`}>
                      {`${item} (${ordersGroup[item].join(",")}) `}
                    </Fragment>
                  ))
                : orders.join(",")}
            </Typography>
            {dateRangeState[0].toISOString() ===
            dateRangeState[1].toISOString() ? (
              <Typography variant="subtitle1">
                <strong>Date: </strong>
                {dateRangeState[0].toISOString().split("T")[0]}
              </Typography>
            ) : (
              <Typography variant="subtitle1">
                <strong>Start Date: </strong>
                {dateRangeState[0].toISOString().split("T")[0]}
                <strong> End Date: </strong>
                {dateRangeState[1].toISOString().split("T")[0]}
              </Typography>
            )}
            {orderLocation ? (
              <Typography variant="subtitle1">
                <strong>Location: </strong>
                {orderLocation.physical_address
                  ? orderLocation.physical_address.complete_address
                  : "Physical address not found"}
              </Typography>
            ) : (
              <></>
            )}
          </Grid>
          <Grid item xs={12} sm={12} className="noprint">
            <Grid container alignItems="center">
              <Grid item xs={12} sm={true}>
                <Typography variant="subtitle1">
                  <strong>Filter Locations </strong>
                </Typography>
                <Select
                  fullWidth
                  label="Filter Locations"
                  onChange={handleFilterChange}
                  name="filter"
                  input={<Input />}
                  value={filter}
                  MenuProps={MenuProps}
                >
                  <MenuItem value="">None</MenuItem>
                  <MenuItem value="3">Friendly Foods</MenuItem>
                  <MenuItem value="4">Produce Market</MenuItem>
                  <MenuItem value="2">Restaurant Depot</MenuItem>
                </Select>
              </Grid>
              <Grid item xs={12} sm="auto" style={{ height: 39 }}>
                <Button
                  style={{ marginLeft: 8 }}
                  color="inherit"
                  variant="contained"
                  onClick={() => handleShowPrices()}
                >
                  {`${!showPrices ? "Show" : "Hide"} Prices`}
                </Button>
              </Grid>
              <Grid item xs={12} sm="auto">
                <div style={{ display: "flex" }}>
                  <Button
                    style={{ marginLeft: 8 }}
                    color="inherit"
                    variant="contained"
                    onClick={() => handleHidePicked()}
                  >
                    {`${hidePicked ? "Show" : "Hide"} Picked Items`}
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          {console.log(orderItems)}
          <Grid item xs={12} sm={12}></Grid>
          <Grid item xs={12} sm={12}>
            <TableContainer>
              <Table
                stickyHeader
                aria-label="sticky table"
                size="small"
                classes={{ root: classes.customTable }}
              >
                <TableHead>
                  <TableRow>
                    {columns[bulkState ? "bulk" : "nonbulk"]
                      .filter((column) => {
                        if (column.id === "order" && orders.length === 1)
                          return false;

                        if (
                          !showPrices &&
                          ["price_per_unit", "price_per_case"].includes(
                            column.id
                          )
                        )
                          return false;

                        return true;
                      })
                      .map((column) => (
                        <TableCell
                          key={`header-${column.id}`}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orderItemsFull.length &&
                    orderItemsFull.map((row, index) =>
                      row.picked && hidePicked ? (
                        <Fragment key={`row-${index}`}></Fragment>
                      ) : (
                        <TableRow hover tabIndex={-1} key={`row-${index}`}>
                          {columns[bulkState ? "bulk" : "nonbulk"]
                            .filter((column) => {
                              if (column.id === "order" && orders.length === 1)
                                return false;

                              if (
                                !showPrices &&
                                ["price_per_unit", "price_per_case"].includes(
                                  column.id
                                )
                              )
                                return false;

                              return true;
                            })
                            .map((column) => {
                              const value = row[column.id];
                              return (
                                <TableCell
                                  key={`column-${column.id}-row-${index}`}
                                  style={{
                                    maxWidth:
                                      column.id === "name" ? 350 : "auto",
                                    textAlign:
                                      column.id === "order"
                                        ? column.align
                                        : "inherit",
                                  }}
                                >
                                  {bulkState &&
                                  column.id === "order" &&
                                  row.dupitems.length ? (
                                    row.dupitems.map((dItem, dIndex) => (
                                      <Fragment
                                        key={`row-${index}-dupitem-${dIndex}-order`}
                                      >
                                        {dItem.order}
                                        <br />
                                        {`(${dItem.order_customer})`}
                                        <br />
                                      </Fragment>
                                    ))
                                  ) : typeof value === "boolean" ? (
                                    "" + value
                                  ) : typeof value === "object" &&
                                    value === null ? (
                                    "N/A"
                                  ) : column.id.includes("quantity") ? (
                                    column.id.includes("unit") ? (
                                      "U: " +
                                      (row.out_of_stock ||
                                      row.unit_quantity === row.units_ordered
                                        ? value
                                        : `${value} / ${row.units_ordered}`)
                                    ) : (
                                      "C: " +
                                      (row.out_of_stock ||
                                      row.case_quantity === row.cases_ordered
                                        ? value
                                        : `${value} / ${row.cases_ordered}`)
                                    )
                                  ) : column.id.includes("price") ? (
                                    `$${value}`
                                  ) : row.weight_type === "r/w" &&
                                    ["name", "item_codee"].includes(
                                      column.id
                                    ) ? (
                                    <b>{value}</b>
                                  ) : (
                                    value || 0
                                  )}
                                  {column.id === "name" && row.out_of_stock && (
                                    <Tooltip
                                      title="Out of stock"
                                      style={{
                                        verticalAlign: "middle",
                                        marginLeft: 5,
                                      }}
                                    >
                                      <BlockIcon color="error" />
                                    </Tooltip>
                                  )}
                                  {orders.length === 1 &&
                                    column.id === "name" &&
                                    row.product !== row.original_product && (
                                      <>
                                        <br />
                                        <span
                                          style={{
                                            marginLeft: 10,
                                            fontStyle: "italic",
                                          }}
                                        >
                                          {`Sub ${row.original_product_name}`}
                                        </span>
                                      </>
                                    )}
                                  {!bulkState && column.id === "order" ? (
                                    <>
                                      <br />({row.order_customer})
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </TableCell>
                              );
                            })}
                        </TableRow>
                      )
                    )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default PickListDetailsPrint;
